import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { WaveSurfer, WaveForm, Region } from "wavesurfer-react";
import Track from "./Components/track";
import "semantic-ui-css/semantic.min.css";
import Home from "./Components/Home";

function App() {
  return <Home />;
}

export default App;
